import React from 'react'

export default function Terms() {
  return (
    <div className="bg-black text-white min-h-screen py-12 px-4">
      <div className="max-w-7xl mx-auto space-y-12">
        <header className="space-y-4">
          <h1 className="text-4xl font-extrabold text-white">Terms & Conditions</h1>
          <p className="text-lg text-gray-300">
            Welcome to Bristu Learning App! These Terms and Conditions ("Terms") govern your access to and use of our website, mobile application, and online services (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms. Please read them carefully.
          </p>
        </header>

        <section className="space-y-10">
          {[
            {
              title: 'Acceptance of Terms',
              content:
                'Using the Bristu Learning App implies acceptance of all terms outlined in this agreement.'
            },
            {
              title: 'Description of Services',
              content:
                'Our platform offers online English courses, downloadable resources, and other educational content.'
            },
            {
              title: 'User Accounts',
              content: (
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li><span className="font-semibold text-white">Eligibility:</span> Users must meet age and other eligibility requirements.</li>
                  <li><span className="font-semibold text-white">Account Responsibility:</span> You are responsible for maintaining account confidentiality and activity.</li>
                  <li><span className="font-semibold text-white">Account Termination:</span> Bristu reserves the right to terminate accounts for violations of our terms.</li>
                </ul>
              )
            },
            {
              title: 'Intellectual Property',
              content: (
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li><span className="font-semibold text-white">Ownership:</span> All materials and content are owned by Bristu Learning App.</li>
                  <li><span className="font-semibold text-white">Restrictions:</span> No part of the content may be copied or redistributed without permission.</li>
                </ul>
              )
            },
            {
              title: 'User Content',
              content: (
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li><span className="font-semibold text-white">Responsibility:</span> Users are responsible for any content they upload or share.</li>
                  <li><span className="font-semibold text-white">Rights Granted:</span> By submitting content, users grant Bristu the right to use it within the platform.</li>
                  <li><span className="font-semibold text-white">Prohibited Content:</span> Content that is offensive, harmful, or illegal is strictly prohibited.</li>
                </ul>
              )
            },
            {
              title: 'Payment and Fees',
              content: (
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li><span className="font-semibold text-white">Pricing:</span> Course prices are clearly listed on our platform.</li>
                  <li><span className="font-semibold text-white">Payment Terms:</span> All transactions must be completed before access is granted.</li>
                  <li><span className="font-semibold text-white">Taxes:</span> Applicable taxes may be added based on your location.</li>
                </ul>
              )
            },
            {
              title: 'Disclaimer of Warranties',
              content: (
                <ul className="list-disc list-inside text-gray-300 space-y-2">
                  <li><span className="font-semibold text-white">"As Is" Basis:</span> All services are provided "as is" without warranties of any kind.</li>
                  <li><span className="font-semibold text-white">No Guarantees:</span> Bristu does not guarantee outcomes or continuous access.</li>
                </ul>
              )
            },
            {
              title: 'Limitation of Liability',
              content:
                'Bristu Learning App is not liable for indirect, incidental, or consequential damages arising from use of the services.'
            },
            {
              title: 'Indemnification',
              content:
                'Users agree to indemnify and hold harmless Bristu Learning App from claims related to misuse of the platform.'
            },
            {
              title: 'Third-Party Links',
              content:
                'We are not responsible for the content or services provided by third-party websites linked from our platform.'
            },
            {
              title: 'Modification of Terms',
              content:
                'We reserve the right to update these Terms at any time. Continued use of our services implies agreement with the revised terms.'
            },
            {
              title: 'Governing Law',
              content:
                'These Terms are governed by the laws of the applicable jurisdiction in which Bristu Learning App operates.'
            },
            {
              title: 'Severability',
              content:
                'If any provision is deemed unenforceable, the remainder of the Terms will remain in full effect.'
            },
            {
              title: 'Entire Agreement',
              content:
                'These Terms constitute the entire agreement between the user and Bristu Learning App.'
            }
          ].map((section, index) => (
            <div key={index} className="bg-gray-900 rounded-2xl p-6 shadow-md space-y-3">
              <h2 className="text-2xl font-bold text-white">{section.title}</h2>
              <div className="text-gray-300 text-base">
                {typeof section.content === 'string' ? <p>{section.content}</p> : section.content}
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}
